import React from 'react';
import type { ChildrenProp, ClassNameProp } from '../common-types';

/**
 * Defines the list properties
 *
 */
export interface ListProps extends ClassNameProp, ChildrenProp {
  /**
   * if the list should have a white background
   */
  background: boolean;
  /**
   * how the divider should look like
   */
  divider: 'inset-lef' | 'inset' | 'full-width' | 'none';
  /**
   * if the list should show a bottom divider
   */
  bottomDivider?: boolean;
}
/**
 * A simple list with different style options
 *
 * @param background if the list should have a white background
 * @param items an array of {@link ListItemProps} that will be rendered within the container
 * @param divider how the divider should look like (options specified by SHUI)
 * @param className the className for the list (container of the items)
 * @param bottomDivider whether to show a bottom border on the last element, recommended with background={false}
 */
export function List({
  background = true,
  divider,
  className,
  children,
  bottomDivider = false,
  ...props
}: Readonly<ListProps>): JSX.Element {
  const classes = ['ehs-list'];
  if (background) {
    classes.push('background');
  }
  classes.push('divider-' + divider);
  if (className) {
    classes.push(className);
  }
  if (bottomDivider) {
    classes.push('bottom-divider');
  }

  return (
    <ul {...props} className={classes.join(' ').trim()}>
      {children}
    </ul>
  );
}
